export default __webpack_public_path__ + "static/media/pictogramBeaconInsurance128.862574c7.svg";